import React from "react";
import ReactMarkdown from "react-markdown";
import { resolveGuaranteeDescriptionContent } from "../../utils/toGuaranteeDescriptionHtml";

const DESCRIPTION_CLASS_NAME = [
  "text-sm leading-relaxed text-gray-600",
  "[&_p]:mb-3 [&_p:last-child]:mb-0",
  "[&_ul]:mb-3 [&_ul]:list-disc [&_ul]:pl-5",
  "[&_ol]:mb-3 [&_ol]:list-decimal [&_ol]:pl-5",
  "[&_li]:mb-1",
  "[&_strong]:font-semibold [&_b]:font-semibold",
  "[&_em]:italic [&_u]:underline",
  "[&_a]:text-[#DD6435] [&_a]:underline",
  "[&_h1]:mb-2 [&_h1]:text-base [&_h1]:font-semibold [&_h1]:text-gray-800",
  "[&_h2]:mb-2 [&_h2]:text-base [&_h2]:font-semibold [&_h2]:text-gray-800",
  "[&_h3]:mb-2 [&_h3]:text-sm [&_h3]:font-semibold [&_h3]:text-gray-800",
  "[&_blockquote]:my-3 [&_blockquote]:border-l-2 [&_blockquote]:border-[#DD6435]/40 [&_blockquote]:pl-3 [&_blockquote]:italic",
].join(" ");

interface GuaranteeDescriptionProps {
  description?: string | null;
  className?: string;
}

function GuaranteeDescription({
  description,
  className,
}: GuaranteeDescriptionProps) {
  const content = resolveGuaranteeDescriptionContent(description ?? "");

  if (!content) {
    return null;
  }

  const classNames = `${DESCRIPTION_CLASS_NAME}${className ? ` ${className}` : ""}`;

  if (content.mode === "markdown") {
    return (
      <div className={classNames}>
        <ReactMarkdown>{content.value}</ReactMarkdown>
      </div>
    );
  }

  return (
    <div
      className={classNames}
      dangerouslySetInnerHTML={{ __html: content.value }}
    />
  );
}

export default GuaranteeDescription;
